import axios from 'axios';
import  store  from '../Redux/store';
import { showLoader, hideLoader } from '../Redux/Slices/loaderSlice';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.counter?.loginDetails?.jwt;
      if (!config.skipLoader) {
      store.dispatch(showLoader());
    }
    if (token) {
       config.headers.Authorization = `Bearer ${token}`;

    }
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    return config;
  },
  (error) => {
    store.dispatch(hideLoader());
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    store.dispatch(hideLoader());
    return response
  },
  (error) => {
     const config = error.config || {};
    if (error.response && error.response.status === 401 && !config.skipAuthInterceptor) {
      if (typeof window.showLogoutPopup === 'function') {
        window.showLogoutPopup();
      }
    }
    store.dispatch(hideLoader());
    return Promise.reject(error);
  }
);

export default axiosInstance;